export var getUpdateSelectors = function (getBase) {
    return {
        isUpdating: function (rootState, id) { var _a, _b; return (id && ((_b = (_a = getBase(rootState).update) === null || _a === void 0 ? void 0 : _a[id]) === null || _b === void 0 ? void 0 : _b.isUpdating)) || false; },
        updateError: function (rootState, id) { var _a, _b; return (id && ((_b = (_a = getBase(rootState).update) === null || _a === void 0 ? void 0 : _a[id]) === null || _b === void 0 ? void 0 : _b.updateError)) || undefined; },
    };
};
